import { EventEmitter, Injectable } from '@angular/core';

import { BaseService } from '../../_services/base.service';

import { NotaFiscal, PedidoNotaFiscal } from '../../_componentes/notafiscal/_models/pedidonotafiscal';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotaFiscalService extends BaseService
{
    public pedidosNotaFiscal$: Observable<PedidoNotaFiscal>;

    constructor() { super(); }

    SelecionarNota = new EventEmitter<NotaFiscal>();

    public setPedidoNotaFiscal(pedido: any)
    {
        const notasFiscais: NotaFiscal[] = pedido.notasFiscais.map((nf) => { return { numero: nf.numero, url: nf.url, shipping_company_id: nf.shipping_company_id, shipping_company_name: nf.shipping_company_name, shipping_company_tracking_code: nf.shipping_company_tracking_code } });
        const lista: PedidoNotaFiscal = { quotation_id: pedido.quotation_id, can_upload_nf: false, notasFiscais };

        this.pedidosNotaFiscal$ = of(lista);
    }
}
